import { render, staticRenderFns } from "./WellBeingWorkshopComp.vue?vue&type=template&id=289c8a7c&scoped=true"
import script from "./WellBeingWorkshopComp.vue?vue&type=script&lang=js"
export * from "./WellBeingWorkshopComp.vue?vue&type=script&lang=js"
import style0 from "./WellBeingWorkshopComp.vue?vue&type=style&index=0&id=289c8a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c8a7c",
  null
  
)

/* custom blocks */
import block0 from "./WellBeingWorkshopComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports